import { MapPin, Phone, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const DeliveryAddress = ({ selectedAddress }) => {
  const navigate = useNavigate();
  return (
    <motion.div
      className="p-4 border-b bg-white"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.2 }}
    >
      <div className="flex justify-between items-center mb-3">
        <h2 className="font-semibold text-gray-800">Delivery Address</h2>
      </div>

      {selectedAddress ? (
        <div className="bg-gray-50 p-3.5 rounded-lg border border-gray-100 cursor-pointer hover:border-green-200 transition-colors">
          <div className="flex items-start gap-3 mb-3">
            <div className="p-2 bg-green-100 rounded-full flex-shrink-0">
              <MapPin className="w-5 h-5 text-green-600" />
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <p className="font-medium text-gray-800">{selectedAddress.societyName}</p>
              </div>
              <p className="text-sm text-gray-600 mt-1">
                {selectedAddress.unitNo ? `${selectedAddress.unitNo}, ` : ''}
                {selectedAddress.plotNo && `plot No ${selectedAddress.plotNo},`}{' '}
                {selectedAddress.pocketNo && `Pocket No ${selectedAddress.pocketNo},`} Sector{' '}
                {selectedAddress.sector}
              </p>
              <p className="text-sm text-gray-600">
                {`${selectedAddress.locality}, ${selectedAddress.district}, ${selectedAddress.state}, ${selectedAddress.pinCode}`}
              </p>
            </div>
          </div>

          {selectedAddress.contactNo && (
            <div className="flex items-center text-sm text-gray-600 border-t border-gray-100 pt-2">
              <Phone className="w-4 h-4 mr-2 text-gray-500" />
              <p>{selectedAddress.contactNo}</p>
            </div>
          )}
        </div>
      ) : (
        <div
          onClick={() => navigate('/profile')}
          className="bg-red-50 p-4 rounded-lg border border-red-100 cursor-pointer text-center"
        >
          <p className="text-red-600 mb-2">No delivery address selected</p>
          <button className="px-4 py-2 bg-green-500 text-white rounded-lg text-sm font-medium">
            Add Address
          </button>
        </div>
      )}
    </motion.div>
  );
};

export default DeliveryAddress;
